"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAddNotesForInspectionDto = instanceOfAddNotesForInspectionDto;
exports.AddNotesForInspectionDtoFromJSON = AddNotesForInspectionDtoFromJSON;
exports.AddNotesForInspectionDtoFromJSONTyped = AddNotesForInspectionDtoFromJSONTyped;
exports.AddNotesForInspectionDtoToJSON = AddNotesForInspectionDtoToJSON;
exports.AddNotesForInspectionDtoToJSONTyped = AddNotesForInspectionDtoToJSONTyped;
/**
 * Check if a given object implements the AddNotesForInspectionDto interface.
 */
function instanceOfAddNotesForInspectionDto(value) {
    if (!('notes' in value) || value['notes'] === undefined)
        return false;
    return true;
}
function AddNotesForInspectionDtoFromJSON(json) {
    return AddNotesForInspectionDtoFromJSONTyped(json, false);
}
function AddNotesForInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'notes': json['notes'],
    };
}
function AddNotesForInspectionDtoToJSON(json) {
    return AddNotesForInspectionDtoToJSONTyped(json, false);
}
function AddNotesForInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'notes': value['notes'],
    };
}
